/**
 * 從陣列中隨機取一個元素。
 * 空陣列回傳 undefined，呼叫端必須顯式處理（專案啟用 strict）。
 */
export const pickRandom = <T>(arr: readonly T[]): T | undefined => {
  if (arr.length === 0) return undefined
  return arr[Math.floor(Math.random() * arr.length)]
}
